import React, { useRef, useState } from 'react';
import { withTranslation, WithTranslation } from "react-i18next";

interface CopyToClipboardOwnProps {
  className?: string;
  style?: React.CSSProperties;
  textString?: string;
}

const CopyToClipboard = (props: CopyToClipboardOwnProps & WithTranslation) => {
  const { t } = props; // [t, i18n]
  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  const [copySuccess, setCopySuccess] = useState('');

  const copyToClipboard = (e: React.MouseEvent<HTMLElement>) => {
    textAreaRef.current?.select();
    // document.execCommand('copy');
    (e.target as HTMLElement).focus();
    navigator.clipboard.writeText(textAreaRef.current?.innerHTML ?? '');
    setCopySuccess((prev) => (prev === '' ? ' ' + t('clipboard.copied') : ''));
  };

  return (
    <div className={props.className} style={{display: "flex"}}>
      <textarea
        rows={1}
        style={props.style}
        ref={textAreaRef}
        value={props.textString}
        readOnly/>
      <div>
        <i className="fa fa-clone" aria-hidden="true" onClick={copyToClipboard}></i>
        {copySuccess}
      </div>
    </div>
  );
};

export default withTranslation('common')(CopyToClipboard);
